import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  dialog: {
    // event details sit at 999999 z-index, because the Freshchat widget is one below that
    // needs !important because zIndex is set by MUI at the element inline level, can't override otherwise
    zIndex: "1000000 !important" as unknown as 1000000,
  },
  paperScrollPaper: {
    width: "450px",
    borderRadius: "5px",
  },
  dialogContent: {
    minHeight: "10rem",
    textAlign: "center",
    padding: "60px 50px 30px",
    position: "relative",
    overflowY: "visible",
    "&:first-child": {
      paddingTop: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 1rem",
    },
  },
  subtitle: {
    marginTop: theme.spacing(1),
  },
  questions: {
    marginTop: theme.spacing(2),
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.25),
  },
  continue: {
    marginBottom: theme.spacing(2),
  },
  disclaimer: {
    "& .linkUrl": {
      color: theme.palette.black,
    },
  },
}));
